// import useAppStore from '@views/app.store'

export const block_formats = `正文=p; 标题 1=h1; 标题 2=h2; 标题 3=h3; 标题 4=h4; 标题 5=h5; 标题 6=h6; `
export const font_size_formats = '10px 12px 14px 16px 18px 24px 36px 48px'

// export const getFamilyFormats = () => {
//   const appStore = useAppStore()
//   return appStore.fontPackList
//     .map(item => `${item.indexNameCN}=${item.indexNameEN.split('.')[0]}`)
//     .join(';')
// }
